import {Component} from 'react'
import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'
import './index.css'

class Login extends Component {
  state = {
    userName: 'rahul',
    userPassword: 'rahul@2021',
    showErrorMsg: false,
    errorMsg: '',
  }

  onChangeUserName = event => {
    this.setState({userName: event.target.value})
  }

  onChagePassword = event => {
    this.setState({userPassword: event.target.value})
  }

  submitForm = async event => {
    event.preventDefault()
    const {userName, userPassword} = this.state
    const userLoginDetails = {
      username: userName,
      password: userPassword,
    }
    const url = 'https://apis.ccbp.in/login'

    const options = {
      method: 'POST',
      body: JSON.stringify(userLoginDetails),
    }
    const response = await fetch(url, options)
    const jsonData = await response.json()
    if (response.ok === true) {
      const jwtToken = jsonData.jwt_token
      const {history} = this.props
      Cookies.set('jwt_token', jwtToken, {expires: 4})
      history.replace('/')
    } else {
      this.setState({
        showErrorMsg: true,
        errorMsg: jsonData.error_msg,
      })
    }
  }

  render() {
    const {userName, userPassword, showErrorMsg, errorMsg} = this.state
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <div className="login-route">
        <form onSubmit={this.submitForm} className="form">
          <img
            className="website-logo"
            alt="website logo"
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png "
          />
          <div className="input-container">
            <label htmlFor="username" className="label">
              USERNAME
            </label>
            <br />
            <input
              type="text"
              id="username"
              className="input"
              placeholder="Enter rahul as username"
              value={userName}
              onChange={this.onChangeUserName}
            />
          </div>
          <div className="input-container">
            <label htmlFor="password" className="label">
              PASSWORD
            </label>
            <br />
            <input
              type="password"
              id="password"
              className="input"
              placeholder="Enter rahul@2021 as password"
              value={userPassword}
              onChange={this.onChagePassword}
            />
          </div>
          <button type="submit" className="login-btn">
            Login
          </button>
          {showErrorMsg && <p className="error-msg">* {errorMsg}</p>}
        </form>
      </div>
    )
  }
}
export default Login
